// Labels and colours for backend enums, shared by every screen.
// Units, categories, types of work, GST rates and HSN/SAC codes are editable Master data: see modules/masters.
import { toOptions } from '../utils/labels';
import type { LabelMap, StatusMap } from '../types/common';

// [label, badge tone, optional icon]. These are the only status names shown anywhere in the app;
// screens, charts and the job board read them from here. Stored values (the keys) never change.
export const QUOTATION_STATUS: StatusMap = {
  draft: ['Draft', 'grey', 'quote'],
  sent: ['Sent', 'blue', 'send'],
  approved: ['Accepted', 'green', 'checkCircle'],
  rejected: ['Rejected', 'red', 'x'],
  expired: ['Expired', 'yellow', 'clock'],
  converted: ['Job created', 'sky', 'wrench'],
};

export const JOB_STATUS: StatusMap = {
  pending: ['Not assigned', 'grey'],
  assigned: ['Assigned', 'blue'],
  in_progress: ['In progress', 'sky'],
  on_hold: ['On hold', 'yellow'],
  completed: ['Ready to invoice', 'green'],
  invoiced: ['Invoiced', 'neutral'],
  cancelled: ['Cancelled', 'red'],
};

export const INVOICE_STATUS: StatusMap = { draft: ['Draft', 'grey', 'quote'], final: ['Issued', 'blue', 'receipt'], cancelled: ['Cancelled', 'red', 'x'] };
export const PAYMENT_STATUS: StatusMap = { unpaid: ['Unpaid', 'red'], partial: ['Partly paid', 'yellow'], paid: ['Paid', 'green'] };
export const RECORD_STATUS: StatusMap = { active: ['Active', 'green'], cancelled: ['Cancelled', 'red'] };

export const PRIORITY: StatusMap = { low: ['Low', 'grey'], normal: ['Normal', 'neutral'], high: ['High', 'yellow'], urgent: ['Urgent', 'red'] };
export const PRIORITY_OPTIONS = toOptions(PRIORITY);

export const STOCK_REASONS: LabelMap = {
  opening: 'Opening stock',
  purchase: 'Purchase',
  purchase_cancelled: 'Purchase cancelled',
  issued_to_service: 'Issued to job',
  returned_from_site: 'Returned from site',
  damaged: 'Damaged',
  adjustment: 'Adjustment',
};

/** Attendance marks: [label, badge tone, short letter]. */
export const ATTENDANCE: StatusMap = {
  present: ['Present', 'green', 'P'],
  half_day: ['Half day', 'yellow', 'H'],
  absent: ['Absent', 'red', 'A'],
  holiday: ['Off', 'neutral', 'O'],
};
